var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserInJoinQueue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 21,
    viewBox: "0 0 38 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99475 11L8.99475 8L5.99475 5",
    stroke: "#178477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99475 8H0.994751",
    stroke: "#178477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9948 14C12.2948 10.11 12.2948 5.89 10.9948 2",
    stroke: "#178477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9099 8.20347C22.8217 8.20347 24.3715 6.59092 24.3715 4.60174C24.3715 2.61255 22.8217 1 20.9099 1C18.9981 1 17.4483 2.61255 17.4483 4.60174C17.4483 6.59092 18.9981 8.20347 20.9099 8.20347Z",
    stroke: "#178477",
    strokeWidth: 1.52728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8443 20.2085H13.9979V18.6078C13.9979 16.6973 14.7273 14.8651 16.0257 13.5141C17.324 12.1632 19.085 11.4043 20.9211 11.4043C22.7573 11.4043 24.5182 12.1632 25.8165 13.5141C27.1149 14.8651 27.8443 16.6973 27.8443 18.6078V20.2085Z",
    stroke: "#178477",
    strokeWidth: 1.52728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M26.3051 1C27.1467 1 27.9538 1.34784 28.5489 1.96701C29.1439 2.58618 29.4783 3.42595 29.4783 4.30159C29.4783 5.17722 29.1439 6.01699 28.5489 6.63616C27.9538 7.25533 27.1467 7.60318 26.3051 7.60318",
    stroke: "#178477",
    strokeWidth: 1.52728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M30.913 1C31.6528 1 32.3622 1.30576 32.8853 1.85002C33.4084 2.39427 33.7022 3.13244 33.7022 3.90214C33.7022 4.67183 33.4084 5.41 32.8853 5.95426C32.3622 6.49852 31.6528 6.80428 30.913 6.80428",
    stroke: "#178477",
    strokeWidth: 1.52728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M28.5541 10.8164C29.7555 11.2919 30.7897 12.1357 31.52 13.2362C32.2503 14.3367 32.6422 15.642 32.6439 16.9794V18.6082H30.5285",
    stroke: "#178477",
    strokeWidth: 1.52728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M32.9129 9.62891C33.9689 10.0469 34.878 10.7886 35.52 11.756C36.1619 12.7233 36.5064 13.8707 36.5079 15.0462V16.478H34.6484",
    stroke: "#178477",
    strokeWidth: 1.52728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInJoinQueue);
export default __webpack_public_path__ + "static/media/user-in-join-queue.a0f357319a3b98658af83b7c80827500.svg";
export { ForwardRef as ReactComponent };